export const objText = {
    titulo: {
        interesado: 'Dirección interesado',
        entidadRepresentada: 'Dirección entidad representada',
    },
    placeholder: {
        descripcionTipoViaDomicilioInteresado: 'Seleccione un tipo de vía',
        nombreDomicilioInteresado: 'Nombre de vía',
        numeroDomicilioInteresado: 'Número',
        pisoDomicilioInteresado: 'Piso',
        puertaDomicilioInteresado: 'Puerta',
        letraDomicilioInteresado: 'Letra',
        escaleraDomicilioInteresado: 'Escalera',
        nombreProvinciaDomicilioInteresado: 'Seleccione una provincia',
        nombreMunicipioDomicilioInteresado: 'Seleccione un municipio',
        codigoPostalDomicilioInteresado: 'Código postal',
        nombrePaisDomicilioInteresado: 'Seleccione un país',
    },
    noOptionsText: 'No hay opciones disponibles',
    textRequired: '*'
}

export const objAttributes = {
    //Grids
    grids: {
        direccionEncabezado: {
            id: 'gridDireccionEncabezado',
        },
        direccionContenerdor1: {
            id: 'gridDireccionContenedor1',
        },
        direccionContenerdor2: {
            id: 'gridDireccionContenedor2',
        },
        direccionContenerdor3: {
            id: 'gridDireccionContenedor3',
        },
    },
    titulo: {
        id: 'direccion',
        name: 'direccion',
    },
    //Inputs
    inputs: {
        nombreDomicilio: {
            type: 'text',
            titlTextField: 'Nombre de vía',
            isRequired: true,
            textRequired: objText.textRequired,
        },
        numeroDomicilio: {
            type: 'text',
            titlTextField: 'Número',
            isRequired: false,
        },
        pisoDomicilio: {
            type: 'text',
            titlTextField: 'Piso',
            isRequired: false,
        },
        puertaDomicilio: {
            type: 'text',
            titlTextField: 'Puerta',
            isRequired: false,
        },
        letraDomicilio: {
            type: 'text',
            titlTextField: 'Letra',
            isRequired: false,
        },
        escaleraDomicilio: {
            type: 'text',
            titlTextField: 'Escalera',
            isRequired: false,
        },
        codigoPostalDomicilio: {
            type: 'text',
            titlTextField: 'Código postal',
            isRequired: true,
            textRequired: objText.textRequired,
        },
    },//Selects
    selects: {
        descripcionTipoViaDomicilio: {
            label: 'Tipo de vía',
            isRequired: true,
            textRequired: objText.textRequired,
        },
        nombreProvinciaDomicilio: {
            label: 'Provincia',
            isRequired: true,
            textRequired: objText.textRequired,
        },
        nombreMunicipioDomicilio: {
            label: 'Municipio',
            isRequired: true,
            textRequired: objText.textRequired,
        },
        nombrePaisDomicilio: {
            label: 'País',
            isRequired: true,
            textRequired: objText.textRequired,
        },
    },
}